import { render, staticRenderFns } from "./GStatistics.vue?vue&type=template&id=48a80272&scoped=true&"
import script from "./GStatistics.vue?vue&type=script&lang=ts&"
export * from "./GStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./GStatistics.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GStatistics.vue?vue&type=style&index=1&id=48a80272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a80272",
  null
  
)

export default component.exports